import { useEffect, useState } from 'react';

type RenderWithDelayProps = {
    children: string | JSX.Element | JSX.Element[],
    renderFallback?: string | JSX.Element | JSX.Element[] | null,
    renderDelay?: number;
};

const RenderWithDelay = ({ children, renderFallback = null, renderDelay = 200 }: RenderWithDelayProps) => {
    const [isTimeElapsed, setIsTimeElapsed] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTimeElapsed(true);
        }, renderDelay);
        return () => clearTimeout(timer);
    }, [renderDelay]);

    return (
        <>
            {isTimeElapsed ? children : renderFallback}
        </>
    );
};

export default RenderWithDelay;